import type { PaletteMode, SimplePaletteColorOptions } from "@mui/material";
import {
	type Colors,
	DarkScales,
	Scales,
} from "web_myplann/Infrastructure/Themes/Colors";

export const getV2PrimaryColors = (
	color: typeof Colors,
	variant: PaletteMode,
): Required<SimplePaletteColorOptions> => {
	const scales = variant === "dark" ? DarkScales : Scales;
	return {
		light: scales.blue[500],
		main: scales.blue[600],
		dark: scales.blue[800],
		contrastText: variant === "light" ? color.White : color.Black,
	};
};
